import apiHandler from "../core/apiHandler";

// 📌 Todas las rutas estarán bajo /api/access
const routeAccessApi = apiHandler("access");

export default routeAccessApi;
